export default __webpack_public_path__ + "static/bookcase2-e1263fd451fe8ae402a853a914103eb4.svg";